<script setup>
import Spinner from "@/Components/Icons/Spinner.vue";
</script>

<template>
    <div class="absolute inset-0 bg-gray-300 opacity-30 flex items-center justify-center">
        <Spinner/>
    </div>
</template>

<style scoped>

</style>
